/* eslint-disable camelcase */
import { GroupListItem } from "@themuse/design-system/lib/components/GroupList/GroupList.d";
import {
    FacetItem,
    PerkAndBenefitAPICategory,
    PerkAndBenefitCategory,
} from "../interfaces/context/searchFacetsContextInterfaces";

/**
 * Experience level items
 */
export const experienceLevelItems: GroupListItem[] = [
    {
        label: "Internship",
        value: "internship",
    },
    {
        label: "Entry Level",
        subLabel: "0 - 1 years",
        value: "entry",
    },
    {
        label: "Mid Level",
        subLabel: "1 - 5 years",
        value: "mid",
    },
    {
        label: "Senior Level",
        subLabel: "5 - 10+ years",
        // TODO: Revise this value once it has been fixed by data/platform.
        value: "senior,management",
    }
];

/**
 * Company Size items
 */
export const companySizeItems: GroupListItem[] = [
    {
        label: "1-50 employees",
        value: "1_50",
    },
    {
        label: "51-200 employees",
        value: "51_200",
    },
    {
        label: "201-500 employees",
        value: "201_500",
    },
    {
        label: "501 - 1,000 employees",
        value: "501_1000",
    },
    {
        label: "1,001 - 5,000 employees",
        value: "1001_5000",
    },
    {
        label: "5,001 - 10,000 employees",
        value: "5001_10000",
    },
    {
        label: "10,000+ employees",
        value: "10000_plus",
    }
];

export const jobCategoryItems: GroupListItem[] = [
    {
        label: "Account Management",
        value: "account_management",
    },
    {
        label: "Accounting and Finance",
        value: "accounting_finance",
    },
    {
        label: "Administration and Office",
        value: "administration_office",
    },
    {
        label: "Advertising and Marketing",
        value: "advertising_marketing",
    },
    {
        label: "Animal Care",
        value: "animal_care",
    },
    {
        label: "Arts",
        value: "arts",
    },
    {
        label: "Business Operations",
        value: "business_operations",
    },
    {
        label: "Cleaning and Facilities",
        value: "cleaning_facilities",
    },
    {
        label: "Computer and IT",
        value: "computer_it",
    },
    {
        label: "Construction",
        value: "construction",
    },
    {
        label: "Customer Service",
        value: "customer_service",
    },
    {
        label: "Data and Analytics",
        value: "data_analytics",
    },
    {
        label: "Design and UX",
        value: "design_ux",
    },
    {
        label: "Education",
        value: "education",
    },
    {
        label: "Energy Generation and Mining",
        value: "energy_generation_mining",
    },
    {
        label: "Entertainment and Travel Services",
        value: "entertainment_travel",
    },
    {
        label: "Farming and Outdoors",
        value: "farming_outdoors",
    },
    {
        label: "Food and Hospitality Services",
        value: "food_hospitality",
    },
    {
        label: "Healthcare",
        value: "healthcare",
    },
    {
        label: "Human Resources and Recruitment",
        value: "human_resources_recruitment",
    },
    {
        label: "Installation, Maintenance, and Repairs",
        value: "installation_maintenance_repairs",
    },
    {
        label: "Legal Services",
        value: "legal",
    },
    {
        label: "Management",
        value: "management",
    },
    {
        label: "Manufacturing and Warehouse",
        value: "manufacturing_warehouse",
    },
    {
        label: "Media, PR, and Communications",
        value: "media_pr_communications",
    },
    {
        label: "Personal Care and Services",
        value: "personal_care",
    },
    {
        label: "Product Management",
        value: "product_management",
    },
    {
        label: "Project Management",
        value: "project_management",
    },
    {
        label: "Protective Services",
        value: "protective_services",
    },
    {
        label: "Real Estate",
        value: "real_estate",
    },
    {
        label: "Retail",
        value: "retail",
    },
    {
        label: "Sales",
        value: "sales",
    },
    {
        label: "Science and Engineering",
        value: "science_engineering",
    },
    {
        label: "Social Services",
        value: "social_services",
    },
    {
        label: "Software Engineering",
        value: "software_engineering",
    },
    {
        label: "Sports, Fitness, and Recreation",
        value: "sports_fitness_recreation",
    },
    {
        label: "Transportation and Logistics",
        value: "transportation_logistics",
    },
    {
        label: "Writing and Editing",
        value: "writing_editing",
    },
];

export const searchRadiusItems: GroupListItem[] = [
    {
        label: "Anywhere",
        value: "",
    },
    {
        label: "5 miles",
        value: "5mi",
    },
    {
        label: "10 miles",
        value: "10mi",
    },
    {
        label: "25 miles",
        value: "25mi",
    },
    {
        label: "50 miles",
        value: "50mi",
    },
    {
        label: "100 miles",
        value: "100mi",
    }
];

/**
 * Radius value when user selects a location for the first time
 */
export const initialRadiusValue = "100mi";

export const postedDateRangeItems: GroupListItem[] = [
    {
        label: "Anytime",
        value: "",
    },
    {
        label: "Last 7 days",
        value: "last_7d",
    },
    {
        label: "Last 14 days",
        value: "last_14d",
    },
    {
        label: "Last 30 Days",
        value: "last_30d",
    }
];

export const diversityInclusionItems: GroupListItem[] = [
    {
        label: "Diversity, Equity, and Inclusion Program",
        value: "diversity_and_inclusion_program"
    },
    {
        label: "Founder led",
        value: "founder_led"
    },
    {
        label: "Female founded/led",
        value: "female_led"
    },
    {
        label: "Black founded/led",
        value: "black_led"
    },
    {
        label: "BIPOC founded/led",
        value: "bipoc_led"
    },
    {
        label: "Latinx founded/led",
        value: "latinx_led"
    },
    {
        label: "Asian founded/led",
        value: "asian_led"
    },
    {
        label: "LGBTQ+ founded/led",
        value: "lgbtq_led"
    },
    {
        label: "Veteran founded/led",
        value: "veteran_led"
    },
    {
        label: "Unconscious Bias Training",
        value: "unconscious_bias_training"
    }
];

export const companyIndustryItems: GroupListItem[] = [
    {
        label: "Accounting",
        value: "accounting"
    },
    {
        label: "Advertising & Agencies",
        value: "advertising_and_agencies"
    },
    {
        label: "Architecture",
        value: "architecture"
    },
    {
        label: "Arts & Music",
        value: "arts_and_music"
    },
    {
        label: "Biotechnology",
        value: "biotechnology"
    },
    {
        label: "Blockchain",
        value: "blockchain"
    },
    {
        label: "Client Services",
        value: "client_services"
    },
    {
        label: "Consulting",
        value: "consulting"
    },
    {
        label: "Consumer Goods & Services",
        value: "consumer"
    },
    {
        label: "Data Science",
        value: "data_science"
    },
    {
        label: "Education",
        value: "education"
    },
    {
        label: "Energy",
        value: "Energy"
    },
    {
        label: "Engineering",
        value: "engineering"
    },
    {
        label: "Entertainment & Gaming",
        value: "entertainment_and_gaming"
    },
    {
        label: "Fashion & Beauty",
        value: "fashion_and_beauty"
    },
    {
        label: "Financial Services",
        value: "finance"
    },
    {
        label: "Fintech",
        value: "fintech"
    },
    {
        label: "Fitness & Wellness",
        value: "fitness_wellness"
    },
    {
        label: "Food & Beverage",
        value: "food"
    },
    {
        label: "Government",
        value: "government"
    },
    {
        label: "Healthcare",
        value: "healthcare"
    },
    {
        label: "Healthtech",
        value: "healthtech"
    },
    {
        label: "Information Technology",
        value: "information_technology"
    },
    {
        label: "Insurance",
        value: "insurance"
    },
    {
        label: "Law",
        value: "law"
    },
    {
        label: "Manufacturing",
        value: "manufacturing"
    },
    {
        label: "Marketing",
        value: "marketing"
    },
    {
        label: "Media",
        value: "media"
    },
    {
        label: "Mortgage",
        value: "mortgage"
    },
    {
        label: "Non-Profit",
        value: "non_profit"
    },
    {
        label: "Pharmaceutical",
        value: "pharmaceutical"
    },
    {
        label: "Public Relations & Communications",
        value: "public_relations_communications"
    },
    {
        label: "Real Estate & Construction",
        value: "real_estate_and_construction"
    },
    {
        label: "Retail",
        value: "retail"
    },
    {
        label: "Social Good",
        value: "social_good"
    },
    {
        label: "Social Media",
        value: "social_media"
    },
    {
        label: "Software",
        value: "software"
    },
    {
        label: "Technology",
        value: "tech"
    },
    {
        label: "Telecom",
        value: "telecom"
    },
    {
        label: "Trading",
        value: "trading"
    },
    {
        label: "Travel & Hospitality",
        value: "travel_and_hospitality"
    },
    {
        label: "Veterinary",
        value: "veterinary"
    }
];

export const convertToFacetItemsFormat = (
    items: FacetItem[]
): GroupListItem[] => items.map(({ code, name }) => ({ label: name, value: code }));

export const flattenPerksAndBenefits = (
    perks_and_benefits: PerkAndBenefitCategory
): GroupListItem[] => perks_and_benefits.reduce((accum, { items }) => [...accum, ...items], []);

export const convertPerksAndBeniftsToNestedFormat = (perks_and_benefits: {
    [key: string]: PerkAndBenefitAPICategory;
}) => {
    const benefits = Object.values(perks_and_benefits).map(({ name, perks }) => ({
        label: name,
        items: convertToFacetItemsFormat(perks),
    }));
    return benefits as PerkAndBenefitCategory;
};
